import { render } from "./App.vue?vue&type=template&id=70635602"
const script = {}

import "./App.vue?vue&type=style&index=0&id=70635602&lang=css"
script.render = render

export default script